import { render } from "./Baselayers.vue?vue&type=template&id=16471a5c"
import script from "./Baselayers.vue?vue&type=script&lang=js"
export * from "./Baselayers.vue?vue&type=script&lang=js"
script.render = render

export default script